/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/blocks/list.module.css';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    ordered: PropTypes.bool,
    isLeftAligned: PropTypes.bool,
    padded: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function ListBlock({
    items = null,
    ordered = false,
    isLeftAligned = false,
    padded = false,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    const Tag = ordered ? 'ol' : 'ul';
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Tag
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [styles.padded]: padded,
                        [styles.isLeftAligned]: isLeftAligned,
                        [styles.ordered]: ordered,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {items.map((item, index) => {
                    const { label, url } = item || {};
                    const key = `${label}-${index + 1}`;
                    return url !== null ? (
                        <li className={styles.item} key={key}>
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                {label}
                            </a>
                        </li>
                    ) : (
                        <li className={styles.item} key={key}>
                            <span>{label}</span>
                        </li>
                    );
                })}
            </Tag>
        </div>
    );
}

ListBlock.propTypes = propTypes;

export default ListBlock;
